module.exports = __webpack_public_path__ + "assets/img/12.da37dd70.png";